var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  transform: "translate(0, -1) scale(1.3)",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_4_G",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "45.51 45.51",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "45.51 45.51",
  type: "scale",
  values: "45.51 45.51;45.51 45.51"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_4_G",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-6.25 -5.817",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-6.25 -5.817",
  type: "translate",
  values: "-6.25 -5.817;-6.25 -5.817"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_3_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "45.51 45.51",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "45.51 45.51",
  type: "scale",
  values: "45.51 45.51;45.51 45.51"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_3_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-6.25 -5.817",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-6.25 -5.817",
  type: "translate",
  values: "-6.25 -5.817;-6.25 -5.817"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_2_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "45.51 45.51",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "45.51 45.51",
  type: "scale",
  values: "45.51 45.51;45.51 45.51"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_2_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-6.25 -5.817",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-6.25 -5.817",
  type: "translate",
  values: "-6.25 -5.817;-6.25 -5.817"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_1_G",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: 0,
  keySplines: "0.576 0 0.737 0.972;0.576 0 0.737 0.972;0.356 0.012 0.833 0.991;0.48 0.038 0.833 0.987;0.167 0.013 0.651 0.972;0.344 0.04 0.372 1;0.535 0 0.833 0.992;0.167 0.015 0.494 1;0.46 0 0.065 1;0.167 0 0.424 1;0 0 0 0",
  keyTimes: "0;0.0287988;0.1341463;0.2196768;0.2987805;0.3773841;0.4935671;0.5433476;0.6346463;0.77575;0.9207317;1",
  repeatCount: 1,
  to: 0,
  type: "rotate",
  values: "0;0;-85;-146;-122;55;-40;-57;17;-21;0;0"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_1_G",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-3.991 -1.874",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-3.991 -1.874",
  type: "translate",
  values: "-3.991 -1.874;-3.991 -1.874"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_1_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "45.51 45.51",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "45.51 45.51",
  type: "scale",
  values: "45.51 45.51;45.51 45.51"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_1_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-6.25 -5.817",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-6.25 -5.817",
  type: "translate",
  values: "-6.25 -5.817;-6.25 -5.817"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_0_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "45.51 45.51",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "45.51 45.51",
  type: "scale",
  values: "45.51 45.51;45.51 45.51"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_L_0_G_N_7_T_0",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "-6.25 -5.817",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-6.25 -5.817",
  type: "translate",
  values: "-6.25 -5.817;-6.25 -5.817"
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_4_G",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0.5;1;1",
  keySplines: "0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.1991951;0.4756098;1",
  path: "M565 884.43 C565,875.6 565,831.43 565,831.43 C565,831.43 565,875.6 565,884.43 C565,884.43 565,884.43 565,884.43",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_3_G_N_7_T_0",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0.5;1;1",
  keySplines: "0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.1991951;0.4756098;1",
  path: "M565 884.43 C565,875.6 565,831.43 565,831.43 C565,831.43 565,875.6 565,884.43 C565,884.43 565,884.43 565,884.43",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_2_G_N_7_T_0",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0.5;1;1",
  keySplines: "0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.1991951;0.4756098;1",
  path: "M565 884.43 C565,875.6 565,831.43 565,831.43 C565,831.43 565,875.6 565,884.43 C565,884.43 565,884.43 565,884.43",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_1_G",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0;0.21;0.33;0.55;0.68;0.8;0.82;0.92;0.98;1;1",
  keySplines: "0.576 0 0.737 0.744;0.576 0 0.737 0.744;0.356 0.467 0.265 1;0.48 0 0.833 0.992;0.167 0.013 0.651 0.972;0.344 0.04 0.372 1;0.535 0 0.833 0.992;0.167 0.015 0.494 1;0.46 0 0.065 1;0.167 0 0.833 1;0 0 0 0",
  keyTimes: "0;0.0287988;0.1341463;0.2195122;0.2987805;0.3773841;0.4935671;0.5433476;0.6346463;0.77575;0.9085366;1",
  path: "M17.5 6.07 C17.5,6.07 17.5,6.07 17.5,6.07 C17.5,6.07 20.53,-0.26 20.53,-0.26 C20.53,-0.26 20.67,-4.48 20.67,-4.48 C20.67,-4.48 18.82,2.73 18.82,2.73 C18.82,2.73 15.57,5.76 15.57,5.76 C15.57,5.76 19.7,5.02 19.7,5.02 C19.7,5.02 19.39,5.63 19.39,5.63 C19.39,5.63 16.14,5.68 16.14,5.68 C16.14,5.68 18.16,6.07 18.16,6.07 C18.16,6.07 17.5,6.07 17.5,6.07 C17.5,6.07 17.5,6.07 17.5,6.07",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_1_G_N_7_T_0",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0.5;1;1",
  keySplines: "0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.1991951;0.4756098;1",
  path: "M565 884.43 C565,875.6 565,831.43 565,831.43 C565,831.43 565,875.6 565,884.43 C565,884.43 565,884.43 565,884.43",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_L_0_G_N_7_T_0",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  keyPoints: "0;0.5;1;1",
  keySplines: "0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.1991951;0.4756098;1",
  path: "M565 884.43 C565,875.6 565,831.43 565,831.43 C565,831.43 565,875.6 565,884.43 C565,884.43 565,884.43 565,884.43",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_0_G_L_4_G_D_0_P_0",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z",
  keySplines: "0.576 0 0.533 1;0.576 0 0.533 1;0.446 0 0.29 1;0 0 0 0",
  keyTimes: "0;0.0121951;0.2134146;0.5;1",
  repeatCount: 1,
  to: "M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z",
  values: "M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z ;M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z ;M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,6.22 1.75,6.22 C1.75,7.27 1.76,7.5 1.95,7.93 C1.95,7.93 1.96,7.97 2.01,8.05 C2.05,8.13 2.1,8.21 2.16,8.3 C2.22,8.39 2.27,8.47 2.32,8.54 C2.38,8.62 2.41,8.65 2.41,8.65 C2.63,8.89 2.74,8.98 2.82,9.03 C2.92,9.1 3.02,9.15 3.32,9.29 C4.64,9.89 6.62,10.5 9.25,10.5 C10.37,10.5 11.36,10.43 12.25,10.32 C12.25,10.32 12.25,11.83 12.25,11.83 C11.35,11.93 10.35,12 9.25,12 C6.56,12 4.47,11.42 2.98,10.78 C2.98,10.78 2.7,10.65 2.7,10.65 C2.13,10.39 1.84,10.26 1.3,9.66 C1.11,9.45 0.78,8.96 0.62,8.64 C0.62,8.64 0.57,8.52 0.57,8.52 C0.25,7.77 0.25,7.25 0.25,6.22 C0.25,6.22 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z ;M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z ;M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_0_G_L_3_G_D_0_P_0",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z",
  keySplines: "0.576 0 0.533 1;0.576 0 0.533 1;0.446 0 0.372 1;0 0 0 0",
  keyTimes: "0;0.0227012;0.2218963;0.5243902;1",
  repeatCount: 1,
  to: "M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z",
  values: "M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z ;M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z ;M11.97 3.48 C12.27,3.43 12.57,3.43 12.87,3.48 C13.37,3.55 15.3,4.11 15.3,4.11 C15.3,4.11 19.02,5.39 19.02,5.39 C19.02,5.39 21.33,6.23 21.99,6.48 C22.67,6.73 23.05,6.85 23.13,7.09 C23.26,7.28 23.24,7.59 23.16,7.75 C23.07,7.98 22.56,8.07 21.91,8.31 C21.02,8.56 20.27,8.8 18.84,9.28 C18.84,9.28 14.65,10.63 14.65,10.63 C13.35,10.95 13.12,11.08 12.69,11.13 C12.42,11.17 12.15,11.17 11.89,11.13 C11.45,11.08 10.98,10.99 9.84,10.72 C9.84,10.72 5.93,9.72 5.93,9.72 C5.84,9.68 5.36,9.55 5.27,9.52 C3.83,9.04 3.63,8.99 2.85,8.74 C1.99,8.4 1.7,8.2 1.61,7.97 C1.47,7.6 1.5,7.47 1.62,7.09 C1.7,6.85 2.1,6.73 2.82,6.41 C3.6,6.05 6.21,5.18 6.21,5.18 C6.21,5.18 9.54,4.15 9.54,4.15 C9.54,4.15 11.47,3.55 11.97,3.48z ;M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z ;M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_0_G_L_2_G_D_0_P_0",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "M1.98 1.72 C1.98,1.72 9,4.5 9,4.5 C9,4.5 9,9.27 9,9.27",
  keySplines: "0.576 0 0.737 0.615;0.576 0 0.737 0.615;0.356 0.522 0.681 0.766;0.48 0.353 0.833 0.833;0.167 0.167 0.651 0.743;0.344 0.253 0.372 1;0.535 0 0.833 0.878;0.167 0.122 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.878;0.167 0.122 0.494 1;0.46 0 0.065 1;0.167 0 0.424 1;0 0 0 0",
  keyTimes: "0;0.0304878;0.1402439;0.2195122;0.2987805;0.3780488;0.4939024;0.5121951;0.5426829;0.5853659;0.6097561;0.6341463;0.7743902;0.9207317;1",
  repeatCount: 1,
  to: "M1.57 1.54 C1.57,1.54 9,4.5 9,4.5 C9,4.5 9,9.35 9,9.35",
  values: "M1.98 1.72 C1.98,1.72 9,4.5 9,4.5 C9,4.5 9,9.27 9,9.27 ;M1.98 1.72 C1.98,1.72 9,4.5 9,4.5 C9,4.5 9,9.27 9,9.27 ;M1.71 1.58 C1.71,1.58 6.74,2.44 9.35,2.92 C10.7,3.16 12.05,3.42 12.05,3.42 ;M1.61 1.5 C1.61,1.5 5.58,2.24 7.95,1.54 C10.52,0.79 12.37,-0.7 12.37,-0.7 ;M1.74 1.61 C1.74,1.61 6.22,3.95 7.26,4.59 C8.54,5.38 10.22,6.19 10.22,6.19 ;M1.59 1.59 C1.59,1.59 8.15,4.11 8.91,4.5 C9.37,5.03 7.13,9.21 7.13,9.21 ;M1.61 1.57 C1.61,1.57 9,4.5 9,4.5 C9,4.5 11.2,8.29 11.2,8.29 ;M1.61 1.56 C1.61,1.56 9,4.5 9,4.5 C9,4.5 10.06,7.49 11.37,8.7 ;M1.72 1.61 C1.72,1.61 9,4.5 9,4.5 C9,4.5 8.8,7.47 11.22,8.81 ;M1.61 1.57 C1.61,1.57 9,4.5 9,4.5 C9,4.5 8.74,8.13 9.17,9.2 ;M1.59 1.57 C1.59,1.57 9,4.5 9,4.5 C9,4.5 8.06,8.97 8.06,8.97 ;M1.68 1.59 C1.68,1.59 9,4.5 9,4.5 C9,4.5 7.64,9.06 7.64,9.06 ;M1.65 1.59 C1.65,1.59 9,4.5 9,4.5 C9,4.5 10.17,9.62 10.17,9.62 ;M1.57 1.54 C1.57,1.54 9,4.5 9,4.5 C9,4.5 9,9.35 9,9.35 ;M1.57 1.54 C1.57,1.54 9,4.5 9,4.5 C9,4.5 9,9.35 9,9.35"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_0_G_L_0_G_D_0_P_0",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z",
  keySplines: "0.576 0 0.833 0.833;0.576 0 0.833 0.833;0.167 0.167 0.737 0.615;0.356 0.522 0.681 0.766;0.48 0.353 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.651 0.743;0.344 0.253 0.372 1;0.535 0 0.833 1;0 0 0 0",
  keyTimes: "0;0.0304878;0.1280488;0.1402439;0.2195122;0.2743902;0.2987805;0.3780488;0.4939024;0.6341463;1",
  repeatCount: 1,
  to: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z",
  values: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M-8.3 -236.27 C-8.3,-236.27 -22.33,-169.71 -22.33,-169.71 C-22.33,-169.71 41.12,-156.25 41.12,-156.25 C41.12,-156.25 55.69,-222.57 55.69,-222.57 C55.69,-222.57 -8.3,-236.27 -8.3,-236.27z ;M-10.35 -235.43 C-10.35,-235.43 -21.56,-168.11 -21.56,-168.11 C-21.56,-168.11 41.57,-157.6 41.57,-157.6 C41.57,-157.6 55.81,-224.19 55.81,-224.19 C55.81,-224.19 -10.35,-235.43 -10.35,-235.43z ;M-10 -236.84 C-10,-236.84 -22.27,-169.87 -22.27,-169.87 C-22.27,-169.87 41.92,-160.41 41.92,-160.41 C41.92,-160.41 48.79,-229.01 48.79,-229.01 C48.79,-229.01 -10,-236.84 -10,-236.84z ;M2.96 -239.02 C2.96,-239.02 -22.04,-175.83 -22.04,-175.83 C-22.04,-175.83 27.45,-157.4 27.45,-157.4 C27.45,-157.4 46.15,-223.03 46.15,-223.03 C46.15,-223.03 2.96,-239.02 2.96,-239.02z ;M9.32 -239.65 C9.32,-239.65 -21.91,-179 -21.91,-179 C-21.91,-179 21.9,-157.95 21.9,-157.95 C21.9,-157.95 45.28,-221.99 45.28,-221.99 C45.28,-221.99 9.32,-239.65 9.32,-239.65z ;M0.19 -237.89 C0.19,-237.89 -24.02,-174.08 -24.02,-174.08 C-24.02,-174.08 20.85,-157.25 20.85,-157.25 C20.85,-157.25 45.28,-221.29 45.28,-221.29 C45.28,-221.29 0.19,-237.89 0.19,-237.89z ;M0.19 -239.65 C0.19,-239.65 -24.02,-176.19 -24.02,-176.19 C-24.02,-176.19 22.26,-157.95 22.26,-157.95 C22.26,-157.95 45.28,-222.34 45.28,-222.34 C45.28,-222.34 0.19,-239.65 0.19,-239.65z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_0_G_L_0_G_D_1_P_0",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.3666667s",
  from: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z",
  keySplines: "0.576 0 0.833 0.833;0.576 0 0.833 0.833;0.167 0.167 0.737 0.615;0.356 0.522 0.681 0.766;0.48 0.353 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.651 0.743;0.344 0.253 0.372 1;0.535 0 0.833 1;0 0 0 0",
  keyTimes: "0;0.0304878;0.1280488;0.1402439;0.2195122;0.2743902;0.2987805;0.3780488;0.4939024;0.6341463;1",
  repeatCount: 1,
  to: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z",
  values: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M-8.3 -236.27 C-8.3,-236.27 -22.33,-169.71 -22.33,-169.71 C-22.33,-169.71 41.12,-156.25 41.12,-156.25 C41.12,-156.25 55.69,-222.57 55.69,-222.57 C55.69,-222.57 -8.3,-236.27 -8.3,-236.27z ;M-10.35 -235.43 C-10.35,-235.43 -21.56,-168.11 -21.56,-168.11 C-21.56,-168.11 41.57,-157.6 41.57,-157.6 C41.57,-157.6 55.81,-224.19 55.81,-224.19 C55.81,-224.19 -10.35,-235.43 -10.35,-235.43z ;M-10 -236.84 C-10,-236.84 -22.27,-169.87 -22.27,-169.87 C-22.27,-169.87 41.92,-160.41 41.92,-160.41 C41.92,-160.41 48.79,-229.01 48.79,-229.01 C48.79,-229.01 -10,-236.84 -10,-236.84z ;M2.96 -239.02 C2.96,-239.02 -22.04,-175.83 -22.04,-175.83 C-22.04,-175.83 27.45,-157.4 27.45,-157.4 C27.45,-157.4 46.15,-223.03 46.15,-223.03 C46.15,-223.03 2.96,-239.02 2.96,-239.02z ;M9.32 -239.65 C9.32,-239.65 -21.91,-179 -21.91,-179 C-21.91,-179 21.9,-157.95 21.9,-157.95 C21.9,-157.95 45.28,-221.99 45.28,-221.99 C45.28,-221.99 9.32,-239.65 9.32,-239.65z ;M0.19 -237.89 C0.19,-237.89 -24.02,-174.08 -24.02,-174.08 C-24.02,-174.08 20.85,-157.25 20.85,-157.25 C20.85,-157.25 45.28,-221.29 45.28,-221.29 C45.28,-221.29 0.19,-237.89 0.19,-237.89z ;M0.19 -239.65 C0.19,-239.65 -24.02,-176.19 -24.02,-176.19 C-24.02,-176.19 22.26,-157.95 22.26,-157.95 C22.26,-157.95 45.28,-222.34 45.28,-222.34 C45.28,-222.34 0.19,-239.65 0.19,-239.65z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z ;M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#time_group",
  attributeName: "opacity",
  attributeType: "XML",
  dur: "1s",
  from: 0,
  to: 1
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "_R_G"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G",
  transform: "translate(10.2, 11) scale(0.01389) translate(-720, -720)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_4_G"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_4_G_D_0_P_0",
  fill: "currentColor",
  fillOpacity: 1,
  fillRule: "nonzero",
  d: "M0.22 -0.23 C0.63,-0.05 1.13,0.13 1.71,0.34 C1.71,0.73 1.75,1.67 1.75,2.18 C1.75,2.18 1.75,5.61 1.75,5.61 C1.75,6.66 1.76,6.89 1.95,7.32 C1.95,7.32 1.96,7.36 2.01,7.44 C2.05,7.51 2.1,7.6 2.16,7.69 C2.22,7.78 2.27,7.86 2.32,7.93 C2.38,8 2.41,8.03 2.41,8.03 C2.63,8.28 2.74,8.37 2.82,8.42 C2.92,8.48 3.02,8.53 3.32,8.67 C4.64,9.28 6.62,9.88 9.25,9.88 C10.37,9.88 11.36,9.81 12.25,9.7 C12.25,9.7 12.25,11.22 12.25,11.22 C11.35,11.32 10.35,11.38 9.25,11.38 C6.56,11.38 4.47,10.8 2.98,10.16 C2.98,10.16 2.7,10.03 2.7,10.03 C2.13,9.77 1.84,9.64 1.3,9.05 C1.11,8.84 0.78,8.35 0.62,8.03 C0.62,8.03 0.57,7.9 0.57,7.9 C0.25,7.16 0.25,6.64 0.25,5.61 C0.25,5.61 0.25,2.18 0.25,2.18 C0.25,1.44 0.21,0.32 0.22,-0.23z"
})), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_3_G_N_7_T_0"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_3_G",
  transform: "translate(9.251, -2.061) translate(-12.375, -7.343)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_3_G_D_0_P_0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 1.5,
  d: "M11.92 1.54 C12.22,1.5 12.53,1.5 12.82,1.54 C13.32,1.61 13.81,1.84 15.08,2.48 C15.08,2.48 18.89,4.38 18.89,4.38 C20.33,5.11 21.36,5.62 22.08,6.08 C22.81,6.55 23.05,6.85 23.13,7.09 C23.25,7.47 23.24,7.88 23.09,8.26 C23.01,8.49 22.75,8.78 21.99,9.21 C21.25,9.62 20.2,10.08 18.71,10.73 C18.71,10.73 14.78,12.43 14.78,12.43 C13.65,12.92 13.21,13.1 12.77,13.16 C12.51,13.19 12.24,13.19 11.98,13.16 C11.54,13.1 11.1,12.92 9.97,12.43 C9.97,12.43 6.04,10.73 6.04,10.73 C5.95,10.69 5.86,10.65 5.77,10.61 C4.43,10.03 3.45,9.6 2.76,9.21 C2,8.78 1.75,8.49 1.66,8.26 C1.51,7.88 1.5,7.47 1.62,7.09 C1.7,6.85 1.94,6.55 2.67,6.08 C3.38,5.62 4.42,5.11 5.86,4.38 C5.86,4.38 9.67,2.48 9.67,2.48 C10.94,1.84 11.43,1.61 11.92,1.54z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_2_G_N_7_T_0"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_2_G",
  transform: "translate(13.75, 2.134) translate(-5.25, -5.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_2_G_D_0_P_0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 1.5,
  d: "M1.98 1.72 C1.98,1.72 9,4.5 9,4.5 C9,4.5 9,9.27 9,9.27"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_1_G_N_7_T_0"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_1_G"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_1_G_D_0_P_0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 1.5,
  d: "M2.17 3 C2.92,1.5 5.06,1.5 5.81,3 C6.48,4.35 5.5,5.94 3.99,5.94 C2.48,5.94 1.5,4.35 2.17,3z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_0_G_N_7_T_0"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_L_0_G",
  transform: "translate(9.656, 2.236) scale(0.02197, 0.02197) translate(0, 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_0_G_D_0_P_0",
  fill: "currentColor",
  fillOpacity: 1,
  fillRule: "nonzero",
  d: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_L_0_G_D_1_P_0",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 0,
  d: "M0.89 -240 C0.89,-240 -25.78,-176.89 -25.78,-176.89 C-25.78,-176.89 39.11,-150.22 39.11,-150.22 C39.11,-150.22 55.11,-217.78 55.11,-217.78 C55.11,-217.78 0.89,-240 0.89,-240z"
})))))));
export default SvgLearn;